// Reference rules HTML (captured by the baccarat page work)
import { getBaccaratRulesHtml } from "../baccaratRulesHtml";

export default getBaccaratRulesHtml("baccarat2");
